import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost } from './client'

/**
 * Settings → Easeedesk → Feedback ticket compliments.
 *
 * Perechile vechi: `settings/easeedesk/feedback_ticket_compliments`,
 * `add_feedback_compliment`, `change_feedback_compliment_status`,
 * `remove_feedback_compliment`.
 *
 * `apiGet` / `apiPost` pun ELE `/api/v2` in fata caii.
 */

export interface Compliment {
  ID: number
  attribute_name: string
  status: number
}

export interface ComplimentsPage {
  title: string
  moduleUrl: string
  compliments: Compliment[]
}

export function complimentsQuery() {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'feedback_ticket_compliments'],
    queryFn: () => apiGet<ComplimentsPage>('/settings/easeedesk/feedback_ticket_compliments'),
  })
}

export function createCompliment(compliment_name: string, active: boolean) {
  return apiPost<{ ok?: boolean; ID?: number }>('/settings/easeedesk/feedback_ticket_compliments', {
    compliment_name,
    status: active ? '1' : '0',
  })
}

export function changeComplimentStatus(compliment: number, on: boolean) {
  return apiPost<{ ok?: boolean }>(`/settings/easeedesk/feedback_ticket_compliments/${compliment}/status`, {
    status: on ? 'on' : 'off',
  })
}

export function removeCompliment(compliment: number) {
  return apiPost<{ ok?: boolean }>(`/settings/easeedesk/feedback_ticket_compliments/${compliment}/remove`, {})
}
